import data from "../../../../../src/FilteredSearch/FilteredSearch.docs.json";
import * as React from 'react';
export default {
  data,
  React
};